module.exports = __webpack_public_path__ + "static/img/logo.6c53d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1/logo.png
// module id = Kr7Y
// module chunks = 1